export const numberOfPointsToEnterTheLeague = 80
